import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useTrainingLesson'

import { TrainingLessonModel } from '@models/types'

const generateTabBarItems = (trainingLesson: TrainingLessonModel) => {
  const urls = generateUrls(trainingLesson)
  const { editTrainingLessonUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editTrainingLessonUrl,
      key: 'details',
      title: trainingLesson?.title || 'Training Lesson Details',
    },
  ]
}

export default generateTabBarItems
